module.exports = __webpack_public_path__ + "img/tutorial_results-sorthl.fe29e8c8.png";